"use client";

import { useState, useRef } from "react";
import VideoModal from "@/components/VideoModal/VideoModal";

import Avatar from "../images/happy-customers/Mahesh-Vargees.png";
import Picture from "../images/happy-customers/bali-reviews-1.jpg";
import Review from "../images/happy-customers/google-review.svg";

import Avatar1 from "../images/happy-customers/San-Jeev.png";
import Picture1 from "../images/happy-customers/bali-reviews-2.jpg";

import Avatar2 from "../images/happy-customers/pratheep.png";
import Picture2 from "../images/happy-customers/bali-reviews-3.jpg";

import Avatar3 from "../images/happy-customers/mayuri.png";
import Picture3 from "../images/happy-customers/bali-reviews-4.jpg";

import Avatar4 from "../images/happy-customers/karunya-raj.png";
import Picture4 from "../images/happy-customers/bali-reviews-5.jpg";

import Avatar5 from "../images/happy-customers/Yagnesh.png";
import Picture5 from "../images/happy-customers/bali-video-review-thumb.jpg";
import Picture6 from "../images/happy-customers/bali-video-review-thumb-1.jpg";

import "@/styles/common/customer-reviews.scss";
import "@/sections/common/happy-customers/happy-customers.scss";
import "@/styles/common/typo.scss";

import Button from "@/components/button/Button";
import Heading from "@/components/heading/heading";

import Image from "next/image";
import { Autoplay } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

const REVIEWS1 = [
    {
        id: 1,
        name: "Mahesh Vargees",
        review: "We booked Dimaak Tours for Bali trip for 9 days and 8 Nights. We are very satisfied with their service. They were very flexible in customising plans before and during the trip. The price is also budget friendly. Their Bali representatives were very kind and took personal care of us. We highly recommend Dimaak Tours for your vacations to be a memorable one.",
        image: Avatar,
    },
    {
        id: 2,
        showImage: true,
        image: Picture,
    },
    {
        id: 3,
        name: "San Jeev",
        review: "Really wanted to give more than 5 ratings for such a wonderful hospitality and care provided .Team was always very much punctual and flexible to change or adopt based on plan changes when needed, considering clients request. Guides were so friendly and easily approachable whenever required.",
        image: Avatar1,
    },
    {
        id: 4,
        showImage: true,
        image: Picture1,
        thumbnail: Picture5,
        videoId: "iAetjYeSG3A",
        videoTitle: "Bali",
    },

    {
        id: 5,
        name: "Yagnesh G",
        review: "We might have many doubts/Queries before international trips. I also had some queries/doubts before my trip to bali and all of them answered by Dimaak Tours through calls/WhatsApp messages quickly. One Day before the journey they will call, remind us to take required documents & They will create a WhatsApp group with our guides & drivers.",
        image: Avatar5,
    },
    {
        id: 6,
        showImage: true,
        image: Picture2,
    },
]
const REVIEWS2 = [
    {
        id: 7,
        name: "Pradeep Kumar",
        review: "We have an amazing experience in Bali with the help of Dimaak tours. They made our trip and stay more easier and comfortable. They provide perfect package with appropriate itrenary which is so good. We didn’t even bother much about the planning and procedure stuffs. It was like just book and go. Choose Dimaak tours and have an wonderful experience.",
        image: Avatar2,
    },
    {
        id: 8,
        showImage: true,
        image: Picture2,
        thumbnail: Picture6,
        videoId: "gbLZ0P17Mf0",
        videoTitle: "Bali",
    },
    {
        id: 9,
        name: "Mayuri",
        review: "We opted for Bali Honeymoon package at Dimak tours and Raj was our POC. He planned the itinerary in such a way that it wasnt hectic for us at the same time we enjoyed thoroughly.. He answered all our queries patiently!.. all the transfers to and fro hotel to sight seeing was planned on time.. Our guide Mini and Kedak at Bali was also very friendly!",
        image: Avatar3,
    },
    {
        id: 10,
        showImage: true,
        image: Picture3,
    },

    {
        id: 11,
        name: "Karunya Raj",
        review: "Thank you Dimaak tours for giving me a wonderful memories in Bali.. The tour was smooth and decently planned by Mr. Mani. gave me the best travel  experience . He is very knowledgeable and helpful with everything I wanted to know and learn about my trip! He also found different fun excursions we could do while we are there. He answered me in a very fast timely manner with all my questions and concerns I had. Planning my trip was a very smooth process because of DIMAAK!!",
        image: Avatar4,
    },
    {
        id: 12,
        showImage: true,
        image: Picture4,
    },
];

const HappyCustomers = () => {
    const [modalStates, setModalStates] = useState(REVIEWS1.map(() => false));
    const [modal2States, setModal2States] = useState(REVIEWS2.map(() => false));
    const swiperRef1 = useRef<any>(null);
    const swiperRef2 = useRef<any>(null);

    const handleEnter = () => {
        swiperRef1.current.swiper.autoplay.stop();
        swiperRef2.current.swiper.autoplay.stop();
    };

    const handleLeave = () => {
        swiperRef1.current.swiper.autoplay.start();
        swiperRef2.current.swiper.autoplay.start();
    };

    const openModal = (index: number, reviewsListNo: number) => {
        if (reviewsListNo === 1) {
            const newModalStates = [...modalStates];
            newModalStates[index] = true;
            setModalStates(newModalStates);
        } else {
            const newModalStates = [...modal2States];
            newModalStates[index] = true;
            setModal2States(newModalStates);
        }
    };

    const closeModal = (index: number, reviewsListNo: number) => {
        if (reviewsListNo === 1) {
            const newModalStates = [...modalStates];
            newModalStates[index] = false;
            setModalStates(newModalStates);
        } else {
            const newModalStates = [...modal2States];
            newModalStates[index] = false;
            setModal2States(newModalStates);
        }
    };

    return (
        <section className="happy-customers-section">
            <div className="container px-4 mx-auto flex flex-col gap-6 sm:gap-14">
                <div className="grid grid-cols-1 gap-6 lg:grid-cols-3">
                    <div className="happy-customers-block col-span-1 flex flex-col justify-center items-start gap-3 sm:gap-6 lg:col-span-1">
                        <small className="font-yesteryear font-extralight">
                            Our Customers Love
                        </small>
                        <Heading as="h2">Travel Experiences</Heading>
                        <p className="lead">
                        Discover what our valued customers have to say about their unforgettable experiences. Read genuine reviews and testimonials showcasing the joy and satisfaction of their journeys with us
                        </p>
                        <div className="button-review flex flex-wrap items-center gap-6">
                            <Button
                                onClick={() =>
                                    window.open(
                                        "https://bit.ly/dimaakreviews",
                                        "_blank"
                                    )
                                }
                                className="flex items-center"
                                variant="orange"
                            >
                                <span>View more Reviews</span>
                            </Button>
                            <Image loading="lazy"
                                src={Review}
                                alt="Review"
                                className="review"
                                
                            />
                        </div>
                    </div>
                    <div className="happy-customers-slider happy-customers-slider-vertical col-span-1 flex-col gap-4 lg:col-span-2 hidden lg:flex">
                        <div
                            className="grid-cols-1 gap-6 lg:grid-cols-2 grid"
                            onMouseEnter={handleEnter}
                            onMouseLeave={handleLeave}
                        >
                            <div className="happy-customers-slider-one happy-customers-slider col-span-1 flex flex-col gap-4 lg:col-span-1">
                                <Swiper
                                    ref={swiperRef1}
                                    slidesPerView={1.5}
                                    spaceBetween={30}
                                    centeredSlides={true}
                                    direction="vertical"
                                    speed={3000}
                                    modules={[Autoplay]}
                                    autoplay={{
                                        delay: 1,
                                        disableOnInteraction: false,
                                        waitForTransition: true,
                                        pauseOnMouseEnter: true,
                                    }}
                                    loop={true}
                                    className="swiper-container"
                                    autoHeight={true}
                                    height={400}
                                >
                                    {REVIEWS1?.map((review, index) => (
                                        <SwiperSlide
                                            key={review.id}
                                            className={`swiper-slide ${
                                                review.showImage
                                                    ? "with-image-h"
                                                    : "without-image-h"
                                            }`}
                                            style={{
                                                height: "100% !important",
                                                color: "red",
                                            }}
                                        >
                                            {review.showImage ? (
                                                <div className="with-image h-full">
                                                    {review.videoId ? (
                                                        <div
                                                            className="picture object-fill h-full"
                                                            onClick={() =>
                                                                openModal(
                                                                    index,
                                                                    1
                                                                )
                                                            }
                                                            style={{
                                                                cursor: "pointer",
                                                            }}
                                                        >
                                                            <Image
                                                                loading="lazy"
                                                                src={
                                                                    review.thumbnail
                                                                }
                                                                alt="Picture"
                                                                className="picture object-fill h-full"
                                                            />
                                                            <div
                                                                className="play-button"
                                                                style={{
                                                                    position:
                                                                        "absolute",
                                                                    top: "50%",
                                                                    left: "50%",
                                                                    transform:
                                                                        "translate(-50%, -50%)",
                                                                    cursor: "pointer",
                                                                }}
                                                            >
                                                                <svg
                                                                    width="61"
                                                                    height="61"
                                                                    viewBox="0 0 61 61"
                                                                    fill="none"
                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                >
                                                                    <circle
                                                                        cx="30.5"
                                                                        cy="30.5"
                                                                        r="30.5"
                                                                        fill="#FFF3ED"
                                                                    />
                                                                    <path
                                                                        d="M42 30L24 40.3923L24 19.6077L42 30Z"
                                                                        fill="#FF4514"
                                                                    />
                                                                </svg>
                                                            </div>
                                                        </div>
                                                    ) : (
                                                        <Image
                                                            loading="lazy"
                                                            src={review.image}
                                                            alt="Picture"
                                                            className="picture object-fill h-full"
                                                        />
                                                    )}

                                                    <VideoModal
                                                        videoTitle={
                                                            review.videoTitle
                                                        }
                                                        videoId={review.videoId}
                                                        isOpen={
                                                            modalStates[index]
                                                        }
                                                        onClose={() => {
                                                            closeModal(
                                                                index,
                                                                1
                                                            );
                                                            swiperRef1.current.swiper.autoplay.start();
                                                            swiperRef2.current.swiper.autoplay.start();
                                                        }}
                                                    />
                                                </div>
                                            ) : (
                                                <div className="without-image p-4 xl:p-6 flex flex-col gap-3 h-full">
                                                    <p className="lead">
                                                        {review.review}
                                                    </p>
                                                    <div className="avatar flex items-center mt-auto gap-3">
                                                        <Image
                                                            loading="lazy"
                                                            src={review.image}
                                                            alt="Avatar"
                                                            className="avatar"
                                                        />
                                                        <span className="font-semibold">
                                                            {review.name}
                                                        </span>
                                                    </div>
                                                </div>
                                            )}
                                        </SwiperSlide>
                                    ))}
                                </Swiper>
                            </div>
                            <div className="happy-customers-slider-two happy-customers-slider col-span-1 flex flex-col gap-4 lg:col-span-1">
                                <Swiper
                                    ref={swiperRef2}
                                    slidesPerView={1.5}
                                    spaceBetween={30}
                                    centeredSlides={true}
                                    direction="vertical"
                                    speed={3000}
                                    modules={[Autoplay]}
                                    autoplay={{
                                        delay: 1,
                                        disableOnInteraction: false,
                                        waitForTransition: true,
                                        pauseOnMouseEnter: true,
                                        reverseDirection: true,
                                    }}
                                    loop={true}
                                    className="swiper-container"
                                    onSlideChange={(e) => {}}
                                    onSwiper={(swiper) => {}}
                                    autoHeight={true}
                                    height={400}
                                >
                                    {REVIEWS2?.map((review, index) => (
                                        <SwiperSlide
                                            key={review.id}
                                            className={`swiper-slide ${
                                                review.showImage
                                                    ? "with-image-h"
                                                    : "without-image-h"
                                            }`}
                                            style={{
                                                height: "100% !important",
                                                color: "red",
                                            }}
                                        >
                                            {review.showImage ? (
                                                <div className="with-image h-full">
                                                    {review.videoId ? (
                                                        <div
                                                            className="picture object-fill h-full"
                                                            onClick={() =>
                                                                openModal(
                                                                    index,
                                                                    2
                                                                )
                                                            }
                                                            style={{
                                                                cursor: "pointer",
                                                            }}
                                                        >
                                                            <Image
                                                                loading="lazy"
                                                                src={
                                                                    review.thumbnail
                                                                }
                                                                alt="Picture"
                                                                className="picture object-fill h-full"
                                                            />
                                                            <div
                                                                className="play-button"
                                                                style={{
                                                                    position:
                                                                        "absolute",
                                                                    top: "50%",
                                                                    left: "50%",
                                                                    transform:
                                                                        "translate(-50%, -50%)",
                                                                    cursor: "pointer",
                                                                }}
                                                            >
                                                                <svg
                                                                    width="61"
                                                                    height="61"
                                                                    viewBox="0 0 61 61"
                                                                    fill="none"
                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                >
                                                                    <circle
                                                                        cx="30.5"
                                                                        cy="30.5"
                                                                        r="30.5"
                                                                        fill="#FFF3ED"
                                                                    />
                                                                    <path
                                                                        d="M42 30L24 40.3923L24 19.6077L42 30Z"
                                                                        fill="#FF4514"
                                                                    />
                                                                </svg>
                                                            </div>
                                                        </div>
                                                    ) : (
                                                        <Image
                                                            loading="lazy"
                                                            src={review.image}
                                                            alt="Picture"
                                                            className="picture object-fill h-full"
                                                        />
                                                    )}

                                                    <VideoModal
                                                        videoTitle={
                                                            review.videoTitle
                                                        }
                                                        videoId={review.videoId}
                                                        isOpen={
                                                            modal2States[index]
                                                        }
                                                        onClose={() => {
                                                            closeModal(
                                                                index,
                                                                2
                                                            );
                                                            swiperRef1.current.swiper.autoplay.start();
                                                            swiperRef2.current.swiper.autoplay.start();
                                                        }}
                                                    />
                                                </div>
                                            ) : (
                                                <div className="without-image p-4 xl:p-6 flex flex-col gap-3 h-full">
                                                    <p className="lead">
                                                        {review.review}
                                                    </p>
                                                    <div className="avatar flex items-center mt-auto gap-3">
                                                        <Image
                                                            loading="lazy"
                                                            src={review.image}
                                                            alt="Avatar"
                                                            className="avatar"
                                                        />
                                                        <span className="font-semibold">
                                                            {review.name}
                                                        </span>
                                                    </div>
                                                </div>
                                            )}
                                        </SwiperSlide>
                                    ))}
                                </Swiper>
                            </div>
                        </div>
                    </div>
                    <div className="happy-customers-slider happy-customers-slider-horizontal col-span-1 flex flex-col gap-4 lg:col-span-1 mt-4 h-32">
                        <Swiper
                            slidesPerView={1.5}
                            spaceBetween={30}
                            centeredSlides={true}
                            direction="horizontal"
                            speed={3000}
                            modules={[Autoplay]}
                            autoplay={{
                                delay: 1,
                                disableOnInteraction: false,
                                waitForTransition: true,
                                pauseOnMouseEnter: true,
                            }}
                            loop={true}
                            className="swiper-container"
                            autoHeight={false}
                            height={100}
                        >
                            {REVIEWS1?.map((review, index) => (
                                <SwiperSlide
                                    key={review.id}
                                    className={`swiper-slide ${
                                        review.showImage
                                            ? "with-image-h"
                                            : "without-image-h"
                                    }`}
                                    style={{
                                        height: "100% !important",
                                        color: "red",
                                    }}
                                >
                                    {review.showImage ? (
                                        <div className="with-image h-full">
                                            {review.videoId ? (
                                                <div
                                                    className="picture object-fill h-full"
                                                    onClick={() =>
                                                        openModal(index, 1)
                                                    }
                                                    style={{
                                                        cursor: "pointer",
                                                    }}
                                                >
                                                    <Image
                                                        loading="lazy"
                                                        src={review.thumbnail}
                                                        alt="Picture"
                                                        className="picture object-fill h-full"
                                                    />
                                                    <div
                                                        className="play-button"
                                                        style={{
                                                            position:
                                                                "absolute",
                                                            top: "50%",
                                                            left: "50%",
                                                            transform:
                                                                "translate(-50%, -50%)",
                                                            cursor: "pointer",
                                                        }}
                                                    >
                                                        <svg
                                                            width="61"
                                                            height="61"
                                                            viewBox="0 0 61 61"
                                                            fill="none"
                                                            xmlns="http://www.w3.org/2000/svg"
                                                        >
                                                            <circle
                                                                cx="30.5"
                                                                cy="30.5"
                                                                r="30.5"
                                                                fill="#FFF3ED"
                                                            />
                                                            <path
                                                                d="M42 30L24 40.3923L24 19.6077L42 30Z"
                                                                fill="#FF4514"
                                                            />
                                                        </svg>
                                                    </div>
                                                </div>
                                            ) : (
                                                <Image
                                                    loading="lazy"
                                                    src={review.image}
                                                    alt="Picture"
                                                    className="picture object-fill h-full"
                                                />
                                            )}
                                        </div>
                                    ) : (
                                        <div className="without-image p-4 xl:p-6 flex flex-col gap-3 h-full">
                                            <p className="lead">
                                                {review.review}
                                            </p>
                                            <div className="avatar flex items-center mt-auto gap-3">
                                                <Image
                                                    loading="lazy"
                                                    src={review.image}
                                                    alt="Avatar"
                                                    className="avatar"
                                                />
                                                <span className="font-semibold">
                                                    {review.name}
                                                </span>
                                            </div>
                                        </div>
                                    )}
                                </SwiperSlide>
                            ))}
                            {REVIEWS2?.map((review, index) => (
                                <SwiperSlide
                                    key={review.id}
                                    className={`swiper-slide ${
                                        review.showImage
                                            ? "with-image-h"
                                            : "without-image-h"
                                    }`}
                                    style={{
                                        height: "100% !important",
                                        color: "red",
                                    }}
                                >
                                    {review.showImage ? (
                                        <div className="with-image h-full">
                                            {review.videoId ? (
                                                <div
                                                    className="picture object-fill h-full"
                                                    onClick={() =>
                                                        openModal(index, 2)
                                                    }
                                                    style={{
                                                        cursor: "pointer",
                                                    }}
                                                >
                                                    <Image
                                                        loading="lazy"
                                                        src={review.thumbnail}
                                                        alt="Picture"
                                                        className="picture object-fill h-full"
                                                    />
                                                    <div
                                                        className="play-button"
                                                        style={{
                                                            position:
                                                                "absolute",
                                                            top: "50%",
                                                            left: "50%",
                                                            transform:
                                                                "translate(-50%, -50%)",
                                                            cursor: "pointer",
                                                        }}
                                                    >
                                                        <svg
                                                            width="61"
                                                            height="61"
                                                            viewBox="0 0 61 61"
                                                            fill="none"
                                                            xmlns="http://www.w3.org/2000/svg"
                                                        >
                                                            <circle
                                                                cx="30.5"
                                                                cy="30.5"
                                                                r="30.5"
                                                                fill="#FFF3ED"
                                                            />
                                                            <path
                                                                d="M42 30L24 40.3923L24 19.6077L42 30Z"
                                                                fill="#FF4514"
                                                            />
                                                        </svg>
                                                    </div>
                                                </div>
                                            ) : (
                                                <Image
                                                    loading="lazy"
                                                    src={review.image}
                                                    alt="Picture"
                                                    className="picture object-fill h-full"
                                                />
                                            )}
                                        </div>
                                    ) : (
                                        <div className="without-image p-4 xl:p-6 flex flex-col gap-3 h-full">
                                            <p className="lead">
                                                {review.review}
                                            </p>
                                            <div className="avatar flex items-center mt-auto gap-3">
                                                <Image
                                                    loading="lazy"
                                                    src={review.image}
                                                    alt="Avatar"
                                                    className="avatar"
                                                />
                                                <span className="font-semibold">
                                                    {review.name}
                                                </span>
                                            </div>
                                        </div>
                                    )}
                                </SwiperSlide>
                            ))}
                        </Swiper>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default HappyCustomers;
